var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5195_133291",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5195_133291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 11.1901L8.44111 14.749C8.27381 14.9163 8.06089 15 7.80233 15C7.54378 15 7.33085 14.9163 7.16355 14.749C6.99625 14.5817 6.9126 14.3688 6.9126 14.1103C6.9126 13.8517 6.99625 13.6388 7.16355 13.4715L11.3613 9.27376C11.5438 9.09125 11.7567 9 12.0001 9C12.2434 9 12.4563 9.09125 12.6388 9.27376L16.8366 13.4715C17.0039 13.6388 17.0875 13.8517 17.0875 14.1103C17.0875 14.3688 17.0039 14.5817 16.8366 14.749C16.6693 14.9163 16.4563 15 16.1978 15C15.9392 15 15.7263 14.9163 15.559 14.749L12.0001 11.1901Z",
    fill: "#1E1531"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.e6f6e22b400b3e43e53fb116caceadf0.svg";
export { ForwardRef as ReactComponent };